import React from "react";
import Frame from "@global/frame/Frame";
import NavigationBar from "@global/navigation-bar/NavigationBar";
import { useBreakpoint } from "@helpers/BreakpointHook";

interface PageProps {
   className?: string;
   children?: React.ReactNode;
}

const PageWrapper: React.FC<PageProps> = ({ className, children }) => {
   const layout = useBreakpoint({
      mobileSm: {
         direction: "vertical",
         minWidth: 320,
         align: "top-center",
         verticalPadding: 8,
         horizontalPadding: 8,
         gap: 16,
         width: "fill"
      },
      tabletSm: {
         verticalPadding: 16,
         horizontalPadding: 16,
         gap: 32
      },
      desktopSm: {
         verticalPadding: 40,
         horizontalPadding: 40,
         gap: 80
      }
   }, true);

   return (
      <Frame className={`page-wrapper ${className}`} layout={layout}>
         <NavigationBar />
         {children}
      </Frame>
   );
}
export default PageWrapper;